// Shared by the broadcast form page and the extracted translation row, so the native <select>
// styling is defined exactly once.
export const selectClassName = `text-sm leading-[18px] outline-none focus:ring-primary
  appearance-none w-full rounded-lg ring-1 ring-blue-stroke transition-all
  duration-300 hover:ring-gray-500 p-3 bg-white`;
